module.exports = __webpack_public_path__ + "static/soot-bd5d6d55826da190e24a5cd2594b718f.jpg";